function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M156.172 19.813c-7.188-13.083-25.156-13.083-32.344 0L2.531 240.566c-7.187 13.082 1.797 29.438 16.172 29.438h242.594c14.379 0 23.363-16.356 16.172-29.438ZM160 170c0 5.523-4.477 10-10 10h-20c-5.523 0-10-4.477-10-10v-70c0-5.52 4.477-10 10-10h20c5.523 0 10 4.48 10 10Zm-40 50c0-11.043 8.953-19.996 20-19.996s20 8.953 20 19.996c0 11.047-8.953 20.004-20 20.004s-20-8.957-20-20.004m0 0",
  style: {
    stroke: "none",
    fillRule: "evenodd",
    fill: "#000",
    fillOpacity: 1
  }
}));
export default SvgWarning;